// extracted by mini-css-extract-plugin
export var modal = "_hr-0";